var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"height":"calc(100vh - 70px)"},attrs:{"element-loading-text":"正在加载页面，请稍候！"}},[_c('iframe',{staticStyle:{"width":"100%","height":"100%"},attrs:{"id":_vm.iframeId,"src":_vm.url,"frameborder":"no"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }